export default "__VITE_ASSET__66b24f1a__"